import { executeRequest, JFSRequest } from '@jfs/network'
import { RootStore } from '../data/store'
import { isSuccessResponse } from './../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'
import { isLocalHostUrl } from './fetchGroupByRiskAudit'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return data
}

const auditForAMidApi = (req: any, abortController?: any) => {
  const request: JFSRequest<{}> = {
    apiPath: isLocalHostUrl
      ? 'http://localhost:8080/api/v1.0/risk/transaction/list'
      : getUrl(APIEndPoints.riskAuditForAMid),
    method: 'POST',
    cache: false,
    config: sitConfig(RootStore.session.getTokens, abortController),
    headers: { ...getHeaders(), ...(isLocalHostUrl && { appIDToken: '66', 'x-channel-id': '66' }) },
    body: req,
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { auditForAMidApi }
